/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FormContextType,
  IconButtonProps,
  RJSFSchema,
  StrictRJSFSchema,
} from '@rjsf/utils';
import { PlusCircle } from 'lucide-react';
import { Button } from '../../Button';

/**
 * A button component for adding new items in a form
 * @param props - The component properties
 */
export default function AddButton<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>({ uiSchema: _uiSchema, ...props }: IconButtonProps<T, S, F>) {
  return (
    <div className="m-0 p-0">
      <Button
        {...props}
        className="w-fit gap-2"
        variant="outline"
        type="button"
      >
        <PlusCircle size={16} /> Add Section
      </Button>
    </div>
  );
}
